import { SweetPath } from 'sweet-path';

export const BOOKING_LOGIN_PATH = new SweetPath('/booking/login');
export const BOOKING_ACTIVATION_PATH = new SweetPath('/booking/activate');
export const BOOKING_FORGOT_PASSWORD_PATH = new SweetPath('/booking/forgot-password');
export const BOOKING_EMAIL_CHANGE_PATH = new SweetPath('/booking/email-change');
export const BOOKING_HOME_PATH = new SweetPath('/booking');
export const BOOKING_DETAIL_PATH = new SweetPath<'slug'>('/booking/:slug');
export const BOOKING_REGISTRATION_PATH = new SweetPath<'slug'>('/booking/:slug/register');
export const BOOKING_CONTACT_PATH = new SweetPath('/booking/contact');
export const BOOKING_THANKYOU_PATH = new SweetPath('/booking/thankyou');
export const BOOKING_SLUG_CONTACT_PATH = new SweetPath<'slug'>('/booking/:slug/contact');
export const BOOKING_SLUG_THANKYOU_PATH = new SweetPath<'slug'>('/booking/:slug/thankyou');
export const BOOKING_SLUG_PAYMENT_RETURN_PATH = new SweetPath<'slug'>('/booking/:slug/payment-return');
export const BOOKING_SLUG_CREDIT_PURCHASE_PATH = new SweetPath<'slug'>('/booking/:slug/credits');
export const BOOKING_SLUG_CREDIT_PURCHASE_RETURN_PATH = new SweetPath<'slug'>('/booking/:slug/credits/payment-return');
export const BOOKING_ACCOUNT_PATH = new SweetPath('/booking/account');
export const BOOKING_ACCOUNT_BOOKINGS_PATH = new SweetPath('/booking/account/bookings');
export const BOOKING_ACCOUNT_BOOKING_DETAIL_PATH = new SweetPath<'reservationId'>(
  '/booking/account/bookings/:reservationId'
);
export const BOOKING_ACCOUNT_INVOICES_PATH = new SweetPath('/booking/account/invoices');
export const BOOKING_ACCOUNT_INVOICE_DETAIL_PATH = new SweetPath<'invoiceId'>('/booking/account/invoices/:invoiceId');
export const BOOKING_ACCOUNT_CREDITS_PATH = new SweetPath('/booking/account/credits');
export const BOOKING_ACCOUNT_CREDIT_PURCHASES_PATH = new SweetPath('/booking/account/credit-purchases');
export const BOOKING_ACCOUNT_PROFILE_PATH = new SweetPath('/booking/account/profile');
export const BOOKING_ACCOUNT_PASSWORD_PATH = new SweetPath('/booking/account/password');
export const BOOKING_ACCOUNT_CREDIT_PURCHASE_DETAIL_PATH = new SweetPath<'purchaseId'>(
  '/booking/account/credit-purchases/:purchaseId'
);
export const BOOKING_GUEST_MANAGE_PATH = new SweetPath<'token'>('/booking/manage/:token');
export const BOOKING_GUEST_MANAGE_STORED_PATH = new SweetPath('/booking/manage');
